const parseBooleanEnv = (value: string | undefined) => value === 'true';

const parseNumberEnv = (value: string | undefined, fallback: number) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

// Относительная база модуля в сборке → абсолютная на хосте модуля; в dev её
// оставляем относительной, чтобы шла через прокси Vite.
const resolveModuleBase = (base: string, host: string) =>
  base.startsWith('/') && !import.meta.env.DEV
    ? `${host.replace(/\/+$/, '')}${base}`
    : base;

export const env = {
  apiBase: import.meta.env.VITE_API_BASE || '',
  apiPrefix: import.meta.env.VITE_API_PREFIX || '',
  // База API «Диска» (зеркало Bitrix24). Пусто → ${apiBase}/doit_disk.
  // Личность — из куки jwt_token (withCredentials), кастомных заголовков не шлём.
  diskApiBase: import.meta.env.VITE_DISK_API_BASE || '',
  // Актор Диска в dev (заголовок X-Bitrix-User-Id, аналог setBitrixUser примера).
  // Пусто → берётся id залогиненного юзера; в проде личность из куки jwt_token.
  diskActorId: import.meta.env.VITE_DISK_ACTOR_ID || '',
  // База API «Справочников» и казначейства (сервис doit_directory). Пусто →
  // ${apiBase}/doit_directory. Личность — из куки jwt_token (withCredentials).
  // Относительный путь (/directory_dev) в dev проксирует Vite, а в сборке он
  // дописывается к хосту API: кука jwt_token принадлежит ему, и nginx этого
  // хоста проксирует /directory_dev на checkerboard вместе с кукой.
  directoryApiBase: resolveModuleBase(
    import.meta.env.VITE_DIRECTORY_API_BASE || '',
    import.meta.env.VITE_DIRECTORY_HOST || import.meta.env.VITE_API_BASE || ''
  ),
  // Dev-оверрайд актора Справочников (заголовок X-DOIT-User-Id). Пусто → личность
  // из куки jwt_token. НЕ путать с X-Bitrix-User-Id диска.
  directoryActorId: import.meta.env.VITE_DIRECTORY_ACTOR_ID || '',
  // API_AUTH_TOKEN сервиса Справочников (шлётся как Authorization: Bearer). Если
  // на сервере задан — без него /v1 отвечает 401. Секрет живёт только в .env.
  directoryAuthToken: import.meta.env.VITE_DIRECTORY_AUTH_TOKEN || '',
  // База модуля телефонии (sip_connector). Публичное API — /api/v1/*, ключ
  // сервиса уходит заголовком x-api-key. Путь относительный: CORS модуля отдаёт
  // константу своего origin, поэтому в dev ходим через прокси Vite.
  sipApiBase: import.meta.env.VITE_SIP_API_BASE || '',
  // Ключ внешнего сервиса для /api/v1/* (scope «crm:calls»). Секрет — только .env.
  sipApiKey: import.meta.env.VITE_SIP_API_KEY || '',
  // База модуля голосовой постановки задач (voice_tasks): /voice/draft,
  // /voice/jobs/{id}, /voice/draft-text, /voice/advice, /voice/create.
  // Путь относительный — CORS сервиса пускает только свой origin, в dev его
  // проксирует Vite (см. vite.config.ts). Личность — кука jwt_token.
  voiceApiBase: import.meta.env.VITE_VOICE_API_BASE || '/voice_tasks',
  frontendUrl: import.meta.env.VITE_FRONTEND_URL || window.location.origin,
  authBypass: parseBooleanEnv(import.meta.env.VITE_AUTH_BYPASS),
  authBypassUserId: parseNumberEnv(import.meta.env.VITE_AUTH_BYPASS_USER_ID, 1),
  authBypassRole: import.meta.env.VITE_AUTH_BYPASS_ROLE || 'admin',
  toolsSalesUrl:
    import.meta.env.VITE_TOOLS_SALES_URL ||
    'https://storerobots.gamechanger.kz/sip_connector_module',
  toolsEdsUrl:
    import.meta.env.VITE_TOOLS_EDS_URL ||
    'https://storerobots.gamechanger.kz/dogovor24-panel/bindings',
  toolsCallsUrl:
    import.meta.env.VITE_TOOLS_CALLS_URL ||
    'https://storerobots.gamechanger.kz/checkerboard',
  toolsBiUrl:
    import.meta.env.VITE_TOOLS_BI_URL ||
    'https://storerobots.gamechanger.kz/bi-reports/rules',
  toolsKnowledgeBaseUrl:
    import.meta.env.VITE_TOOLS_KNOWLEDGE_BASE_URL ||
    'https://storerobots.gamechanger.kz/module_bz/',
  toolsTaskControlUrl:
    import.meta.env.VITE_TOOLS_TASK_CONTROL_URL ||
    'https://storerobots.gamechanger.kz/control_tasks/',
  toolsTimeReportUrl:
    import.meta.env.VITE_TOOLS_TIME_REPORT_URL ||
    'https://storerobots.gamechanger.kz/time_manager_module/',
  toolsAiFilesUrl:
    import.meta.env.VITE_TOOLS_AI_FILES_URL ||
    'https://storerobots.gamechanger.kz/report-analyzer/',
  toolsLogisticsUrl:
    import.meta.env.VITE_TOOLS_LOGISTICS_URL ||
    'https://storerobots.gamechanger.kz/module-chat/test',
  isDev: import.meta.env.DEV,
} as const;
